﻿(function () {
  "use strict";

  var block = document.querySelector(".deposit-pricing-block");
  if (!block) return;

  var depositPct  = parseFloat(block.dataset.depositPct)  || 50;
  var variancePct = parseFloat(block.dataset.variancePct) || 0;
  var roundWhole  = block.dataset.roundWhole !== "false";

  // Build variant → price map from the product JSON embedded in the page
  var variantsMap = {};
  var productJsonEl = document.querySelector("script[data-product-json]");
  if (productJsonEl) {
    try {
      var productData = JSON.parse(productJsonEl.textContent);
      if (productData && productData.variants) {
        productData.variants.forEach(function (v) {
          variantsMap[String(v.id)] = v.price;
        });
      }
    } catch (e) {}
  }

  function getUrlVariantId() {
    try {
      return new URLSearchParams(window.location.search).get("variant");
    } catch (e) { return null; }
  }

  var urlVariantId = getUrlVariantId();
  var initPrice = (urlVariantId && variantsMap[urlVariantId])
    ? variantsMap[urlVariantId]
    : parseInt(block.dataset.basePrice, 10) || 0;

  var currentPrice = initPrice;

  function formatMoney(paise) {
    if (roundWhole) {
      var rupees = Math.round(paise / 100);
      return "Rs.\u00a0" + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(paise, window.Shopify.money_format || "Rs. {{amount}}");
    }
    return "Rs.\u00a0" + (paise / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function setText(selector, value) {
    var el = block.querySelector(selector);
    if (el) el.textContent = value;
  }

  function render(priceInPaise) {
    var dep    = Math.round(priceInPaise * depositPct  / 100);
    var varAmt = Math.round(priceInPaise * variancePct / 100);
    var min    = priceInPaise - varAmt;
    var max    = priceInPaise + varAmt;
    var balMin = min - dep;
    var balMax = max - dep;

    setText(".dp-price",       formatMoney(priceInPaise));
    setText(".dp-range-min",   formatMoney(min));
    setText(".dp-range-max",   formatMoney(max));
    setText(".dp-deposit-now strong", formatMoney(dep));
    setText(".dp-balance-min", formatMoney(balMin));
    setText(".dp-balance-max", formatMoney(balMax));
  }

  function recalculate(priceInPaise) {
    if (!priceInPaise || priceInPaise === currentPrice) return;
    currentPrice = priceInPaise;
    render(priceInPaise);
  }

  // Initial render — ensures JS-formatted values override Liquid output
  render(initPrice);

  // Variant input polling (covers themes using hidden/select input[name="id"])
  var variantInput =
    document.querySelector('input[name="id"]') ||
    document.querySelector('select[name="id"]');

  var lastVariantId = variantInput
    ? String(variantInput.value)
    : (urlVariantId || null);

  function checkVariant() {
    var vid = variantInput ? String(variantInput.value) : null;
    if (!vid || vid === lastVariantId) return;
    lastVariantId = vid;
    var price = variantsMap[vid];
    if (price != null) recalculate(price);
  }

  setInterval(checkVariant, 200);
  document.addEventListener("change", checkVariant);

  // Shopify theme variant events (variant:changed / variant:change)
  function onVariantEvent(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || variant.price == null) return;
    recalculate(variant.price);
  }
  document.addEventListener("variant:changed", onVariantEvent);
  document.addEventListener("variant:change",  onVariantEvent);

  // URL-based variant switching (popstate + patched pushState/replaceState)
  window.addEventListener("popstate", function () {
    var vid = getUrlVariantId();
    if (vid && variantsMap[vid] && vid !== lastVariantId) {
      lastVariantId = vid;
      recalculate(variantsMap[vid]);
    }
  });

  ["pushState", "replaceState"].forEach(function (method) {
    var orig = history[method].bind(history);
    history[method] = function (state, title, url) {
      orig(state, title, url);
      try {
        var params = new URLSearchParams(
          typeof url === "string" ? url.split("?")[1] || "" : ""
        );
        var vid = params.get("variant");
        if (vid && variantsMap[vid] && vid !== lastVariantId) {
          lastVariantId = vid;
          recalculate(variantsMap[vid]);
        }
      } catch (e) {}
    };
  });

})();

